import {
  deleteDoc,
  getDocs,
  orderBy,
  query,
  setDoc,
} from "firebase/firestore/lite";

import { FirestoreRefs } from "igfd-commons/src/firebase/refs";

import { FirestoreProductDocument, Product } from "@dashboard/types/product";

import { readProduct, writeProduct } from "./firestore-converter/product";

export interface ProductApi {
  fetchProducts(restaurantUuid: string): Promise<Product[]>;
  setProduct(product: Product, isNew: boolean): Promise<void>;
  deleteProduct(restaurantUuid: string, productId: string): Promise<void>;
}

/**
 * An implementation of the ProductApi that uses Firestore as the backend.
 */
export class FirestoreBackedProductApi implements ProductApi {
  private firestoreRefs: FirestoreRefs;

  constructor(params: { firestoreRefs: FirestoreRefs }) {
    this.firestoreRefs = params.firestoreRefs;
  }

  public fetchProducts(restaurantUuid: string): Promise<Product[]> {
    return getDocs(
      query(
        this.firestoreRefs.products(restaurantUuid),
        // createdAt is always set (for all products), and is used to order the products.
        orderBy("createdAt", "desc")
      )
    ).then((querySnapshot) =>
      querySnapshot.docs
        .map((doc) => doc.data() as FirestoreProductDocument)
        .map(readProduct)
    );
  }

  public setProduct(product: Product, isNew: boolean): Promise<void> {
    const firestoreProduct = writeProduct(this.firestoreRefs, product, isNew);
    return setDoc(
      this.firestoreRefs.product(product.restaurantUuid, product.id),
      firestoreProduct,
      {
        merge: true,
      }
    );
  }

  // This would be moved to an API call and handled in the backend later on
  public deleteProduct(
    restaurantUuid: string,
    productId: string
  ): Promise<void> {
    return deleteDoc(this.firestoreRefs.product(restaurantUuid, productId));
  }
}
